import { useQuery } from "@tanstack/react-query";
import { fetchFranchiseById } from "services/franchise";

export default function FranchiseeForm() {
  // const franchiseId = localStorage.getItem("franchise_id");

  // const { data: franchiseData } = useQuery(
  //   ["fetch-franchise-by-id"],
  //   () => fetchFranchiseById(franchiseId),
  //   {
  //     enabled: !!franchiseId,
  //     staleTime: STALE_TIME,
  //     select: (res) => res || [],
  //     onSuccess: (res) => {
  //       console.log("Franchise data fetched:", res);
  //     },
  //     onError: (err) => {
  //       console.error("Error fetching zone data:", err);
  //     },
  //   }
  // );

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "Arial, sans-serif",
        margin: 0,
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "90%",
          margin: "0 auto",
          border: "1px solid #000",
          padding: "10px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            border: "1px solid #000",
            padding: "10px",
          }}
        >
          <h2
            style={{
              margin: 0,
              textTransform: "uppercase",
              textDecoration: "underline",
              fontSize: "24px",
              fontWeight: "bold",
            }}
          >
            Laboratory Information Management System
          </h2>
          <p
            style={{
              margin: "5px 0 0",
              fontSize: "14px",
            }}
          >
            New Delhi/India, E-mail :{" "}
            <a
              href="mailto:aarggvtech@gmail.com"
              style={{
                color: "black",
                textDecoration: "none",
              }}
            >
              aarggvtech@gmail.com
            </a>
          </p>
        </div>

        <h3
          style={{
            textAlign: "center",
            textDecoration: "underline",
            margin: "20px 0",
            fontWeight: "bold",
          }}
        >
          NEW FRANCHISEE DATA
        </h3>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "30px",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                1) NAME -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                2) FATHER NAME -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                rowSpan="5"
              >
                3) ADDRESS -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                P.O. -
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="2"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                DISTRICT -
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="2"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                STATE -
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="2"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                PIN CODE -
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="2"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                rowSpan="2"
              >
                4) MOBILE NO. -
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                1)
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="2"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                2)
              </td>
              <td
                style={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="2"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                5) E-mail ID. -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                6) Associate Code -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                7) Regarding Area -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                8) PAYMENT TERMS -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                9) DEPOSIT AMOUNT -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                10) CODE opening date -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
              >
                11) Name of Marketing Person -
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  verticalAlign: "top",
                  height: "30px",
                }}
                colSpan="3"
              ></td>
            </tr>
          </tbody>
        </table>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            margin: "40px 0 20px",
          }}
        >
          <div
            style={{
              width: "30%",
              height: "80px",
              border: "2px solid #000",
            }}
          ></div>
          <div
            style={{
              width: "30%",
              height: "80px",
              border: "2px solid #000",
            }}
          ></div>
          <div
            style={{
              width: "30%",
              height: "80px",
              border: "2px solid #000",
            }}
          ></div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              width: "30%",
              textDecoration: "underline",
            }}
          >
            Director Signature
          </div>
          <div
            style={{
              width: "30%",
              textDecoration: "underline",
            }}
          >
            Franchisee Signature
          </div>
          <div
            style={{
              width: "30%",
              textDecoration: "underline",
            }}
          >
            Marketing Person Signature
          </div>
        </div>

        <div>
          <table
            style={{
              width: "100%",
              marginTop: "20px",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    width: "50%",
                    verticalAlign: "top",
                  }}
                >
                  <p style={{ fontWeight: "bold" }}>*** Document Issue :-</p>
                  <p style={{ color: "red" }}>
                    (Please fully fill up this form)
                  </p>
                </td>
                <td
                  style={{
                    width: "50%",
                    verticalAlign: "top",
                  }}
                >
                  <p>
                    01){" "}
                    <b>
                      <u>Aadhar</u>
                    </b>{" "}
                    card xerox
                  </p>
                  <p>02) 2 copy passport size photo</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
